import Vue from 'vue'
import App from './components/App.vue'

new Vue({
    el: '#app-wrap',
    components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js